module.exports = __webpack_public_path__ + "static/media/clubmember.ab6420ea.svg";